import script from "./VenueView.vue?vue&type=script&setup=true&lang=js"
export * from "./VenueView.vue?vue&type=script&setup=true&lang=js"

import "./VenueView.vue?vue&type=style&index=0&id=49e60641&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49e60641"]])

export default __exports__